import { ErrorBoundary } from 'react-error-boundary'
import { hydrate, render } from "react-dom";
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import Fallback from './components/screens/Fallback'
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById("root");
if (rootElement && rootElement.hasChildNodes()) {
  hydrate(
    <ErrorBoundary fallbackRender={Fallback}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>,
  rootElement)
} else {
  render(
    <ErrorBoundary fallbackRender={Fallback}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>,
  rootElement)
}

reportWebVitals();
